import { manualRetryExtraction } from "../../../services/conversationService";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export function useRetryExtration() {
  const handleRetry = async (workspaceId, conversationId) => {
    try {
      const response = await manualRetryExtraction({
        workspaceId,
        conversationId,
      });
      if (response.status === 200) {
        message.success(
          "Extraction complete. Your extraction status will be updated soon."
        );
      }
    } catch (e) {
      showErrorToast(e, "Retry Extraction failed");
    }
  };

  return { handleRetry };
}
